import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  subscriptionPlanUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'subscription'}`;
  purchaseHistoryUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'subscription/purchase-history'}`;
  usageUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'rfp/dashboard'}`;
  profileUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}`;
  authenticationUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'get-auth-settings'}`;
  updateTwoFactAuthenticationUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'set-auth-settings'}`;
  updatePasswordUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'change_password'}`;
  updateProfileUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'users'}`;
  companyLogoUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'company-logo'}`;
  updateCompanyLogoUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'company-logo'}`;
  loadProfileLogo = `${AppSettings.EMAIL_API_ENDPOINT}/${'profile-image'}`;
  loadCompanyLogo = `${AppSettings.EMAIL_API_ENDPOINT}/${'logo-image'}`;
  companylogoBS: BehaviorSubject<any> = new BehaviorSubject<any>({});
  logoUploadUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${'upload-logo'}`;

  constructor(private readonly http: HttpClient) {}

  getSubscriptionPlan() {
    return this.http.get(this.subscriptionPlanUrl);
  }
  getPurchaseHistory() {
    return this.http.get(this.purchaseHistoryUrl);
  }

  getPurchase() {
    return this.http.get(this.purchaseHistoryUrl);
  }

  getUsage() {
    const selectedApps = localStorage.getItem('selectedApps');

    let module = ''; // default

    if (selectedApps === 'infosecurity') {
      module = 'infosec';
    } else if (selectedApps === 'rfpcontract') {
      module = 'rfp';
    } else if (selectedApps === 'contract') {
      module = 'contract';
    }

    const usageUrl = `${AppSettings.EMAIL_API_ENDPOINT}/${module}/dashboard`;

    return this.http.get(usageUrl);
  }

  getProfile(id: number) {
    return this.http.get(`${this.profileUrl}/${id}`);
  }

  getAuthentication() {
    return this.http.get(this.authenticationUrl);
  }

  updateTwoWayAuthentication(data: any) {
    return this.http.post(this.updateTwoFactAuthenticationUrl, data);
  }

  updatePassword(data: any) {
    return this.http.post(this.updatePasswordUrl, data);
  }

  updateProfile(data: any) {
    return this.http.put(this.updateProfileUrl, data);
  }

  getCompanyLogo() {
    return this.http.get(this.companyLogoUrl);
  }

  loadProfileImage(profileName: string) {
    return this.http.get(`${this.loadProfileLogo}/${profileName}`, {
      responseType: 'blob',
    });
  }

  loadLogoImage(profileName: string) {
    return this.http.get(`${this.loadCompanyLogo}/${profileName}`, {
      responseType: 'blob',
    });
  }
  updateCompanyLogo(formData: FormData) {
    return this.http.post(this.logoUploadUrl, formData);
  }
}
